import { CSSInterpolation } from "@emotion/css/dist/declarations/src/create-instance";

import { Theme } from '@mui/material/styles'

export const SideBarStyle : (theme: Theme) => Record<string, CSSInterpolation> = (theme) => ({
	root: {},
	bodyOpen: {
		position: 'relative',
		width: "241px",
		height: '100vh',
		background: '#025949',
	},
	bodyClose: {
		width: "61px",
		'& .MuiBox-root': {
			display: "flex",
			justifyContent: 'center',
		}
	},
	header: {
		display: "flex",
		alignItems: "center",
		cursor: "pointer",
	},
	logoOpen: {
		color: "inherit",
		height: "25px",
		padding: "15px",
		marginLeft: "4px",
		marginTop: "15px"
	},
	logoClose: {
		marginLeft: "0px"
	},
	headerTitle: {
		'&.MuiTypography-root': {
			fontSize: '1rem',
			fontWeight: 700,
			letterSpacing: '-0.5px',
			color: '#fff',
			cursor: 'pointer',
			marginTop: '0px'
		}
	},
	control: {
		height: "50px",
		display: 'flex',
		justifyContent: 'right',
		padding: '16px',
	},
	controlMain: {
		height: "50px",
		display: 'flex',
		justifyContent: 'right',
		padding: '16px',
	},
	iconBtnReset: {
		marginRight: '16px',
		'&.MuiIconButton-root': {
			padding: 0,
			margin: 0,
		}
	},
	iconBtnResetSideBar: {
		'&.MuiIconButton-root': {
			padding: 0,
			margin: 0,
			width: 'auto',
			height: 'auto',
		}
	},
	iconButtonMarginRight: {
		marginRight: '16px',
	},
	iconToggle: {
		color: '#fff',
		cursor: 'pointer',
		margin: '16px'
	},
	iconBtnList: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '24px',
		height: '24px',
	},
	toggle: {
		transform: 'rotate(180deg)',
		transition: 'transform 0.3s ease',
	},
	subSideMenuBoxOpen: {
		position: 'relative',
		width: "241px",
		height: '100vh',
		background: '#117c68',
	},
	subSideMenuBoxClose: {
		width: "61px !important",
		'& .MuiBox-root': {
			display: "flex",
			justifyContent: 'center',
		}
	},
	subSideMenuList: {
		'&.MuiListItem-root': {
			padding: 0,
		}
	},
	listButton: {
		'&.MuiListItemButton-root': {
			padding: '8px 16px',
			minHeight: '48px',
			color: '#fff',
			'&:hover': {
				backgroundColor: 'rgba(255, 255, 255, 0.08)',
			},
		}
	},
	listButtonActive: {
		'&.MuiListItemButton-root': {
			backgroundColor: 'rgba(255, 255, 255, 0.12)',
		}
	},
	listIconSideBar: {
		'&.MuiListItemIcon-root': {
			minWidth: '40px',
			color: '#fff',
		}
	},
	stepperBox: {
		padding: '24px 16px',
	},
	stepperBoxOpen: {
		width: '100%',
	},
	stepperBoxClose: {
		width: '61px',
		padding: '0 8px',
	},
	stepper: {
		'&.MuiStepper-root': {
			padding: 0,
		},
		'& .MuiStepConnector-root': {
			marginLeft: '16px',
		}
	},
	step: {
		'&.MuiStep-root': {
			padding: 0,
		},

	},
	stepLabel: {
		'&.MuiStepLabel-root': {
			cursor: 'pointer',
			padding: '4px 8px',
			'& .MuiStepLabel-iconContainer': {
				paddingRight: '8px',
			}
		},
	},
	stepLabelActive: {
		'&.MuiStepLabel-root': {
			'& .MuiStepLabel-labelContainer': {
				color: '#fff',
			}
		}
	},
	stepLabelInactive: {
		'&.MuiStepLabel-root': {
			'& .MuiStepLabel-labelContainer': {
				color: 'rgba(255, 255, 255, 0.6)',
			}
		}
	},
	stepLabelCurrent: {
		padding: 5,
		borderRadius: 3,
		background: '#def8f5 !important',
		'&.MuiStepLabel-root': {
			'& .MuiStepLabel-labelContainer': {
				color: '#025949',
				fontWeight: 600,
			}
		}
	},
	stepLabelDisabled: {
		'&.MuiStepLabel-root': {
			cursor: 'not-allowed',
			'& .MuiStepLabel-labelContainer': {
				color: 'rgba(255, 255, 255, 0.3)',
			}
		}
	},
	stepLabelText: {
		fontSize: '0.875rem',
		lineHeight: 1.4,
	},
	teacherGuideButton: {
		'&.MuiButton-root': {
			width: '100%',
			height: '64px',
			backgroundColor: '#11312B',
			color: '#fff',
			borderRadius: '4px',
			fontSize: '16px',
			fontWeight: 500,
			padding: '16px',
			boxSizing: 'border-box',
			textTransform: 'none',
			'&:hover': {
				backgroundColor: '#0E2723',
			},
			'& svg': {
				marginRight: '8px',
			}
		}
	}
});
